import { render, staticRenderFns } from "./ListMotoristaMensagemPushView.vue?vue&type=template&id=1f6bee6e&"
import script from "./ListMotoristaMensagemPushView.vue?vue&type=script&lang=ts&"
export * from "./ListMotoristaMensagemPushView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports